import Vue from "vue";
import App from "./App.vue";
import router from './router'
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import ReadMore from "vue-read-more";
// https://www.npmjs.com/package/vue-number-animation
import VueNumber from "vue-number-animation";

// https://kazupon.github.io/vue-i18n/
import i18n from './i18n'
// https://www.npmjs.com/package/vue-responsive-video-background-player
import VideoBackground from "vue-responsive-video-background-player";

// https://ssense.github.io/vue-carousel/
import VueCarousel from "vue-carousel";

// https://www.npmjs.com/package/vue-intersection-observer
// OBSERVER PARA RODAR ANIMACAO LAZY

import "vue-easy-pie-chart/dist/vue-easy-pie-chart.css";

// https://animate.style/
import "animate.css";

// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/default.css";

// https://codespots.com/library/item/231
import Textra from "vue-textra";

// https://github.com/hilongjw/vue-lazyload
import VueLazyload from "vue-lazyload";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(ReadMore);

Vue.use(VueNumber);

Vue.use(VueCarousel);

Vue.use(Textra);

const errorimage = require("./assets/img/errorIcon.png");

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  attempt: 1,
  lazyComponent: true,
});

Vue.component("video-background", VideoBackground);

Vue.config.productionTip = false;

// use beforeEach route guard to set the language
router.beforeEach((to, from, next) => {

  // use the language from the routing param or default language
  let language = to.params.lang;
  if (!language) {
    language = 'pt-br'
  }

  // set the current language for i18n.
  i18n.locale = language
  next()
})

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
